export enum CardType {
  VISA = 'visa',
  MASTERCARD = 'mastercard',
  AMEX = 'amex',
  DINERS = 'diners',
  DISCOVER = 'discover',
  JCB = 'jcb',
}

export const cardTypeIcons: Record<CardType, string> = {
  [CardType.VISA]: require('assets/icons/payments-light/visa.png'),
  [CardType.MASTERCARD]: require('assets/icons/payments-light/mastercard.png'),
  [CardType.AMEX]: require('assets/icons/payments-light/amex.png'),
  [CardType.DINERS]: require('assets/icons/payments-light/diners.png'),
  [CardType.DISCOVER]: require('assets/icons/payments-light/discover.png'),
  [CardType.JCB]: require('assets/icons/payments-light/jcb.png'),
};

export function getCardType(cardNumber: string): CardType | null {
  if (!cardNumber) return null;
  const numberStripped = cardNumber.replace(/\s+/g, '');
  const cards: Record<CardType, RegExp> = {
    visa: /^4[0-9]{12}(?:[0-9]{3})?/,
    mastercard: /^5[1-5][0-9]{14}/,
    amex: /^3[47][0-9]{13}/,
    diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}/,
    discover: /^6(?:011|5[0-9]{2})[0-9]{12}/,
    jcb: /^(?:2131|1800|35\d{3})\d{11}/,
  };
  for (const card in cards) {
    if (cards[card as CardType].test(numberStripped)) {
      return card as CardType;
    }
  }
  return null;
}

export function getCardTypeIcon(type: CardType): string {
  return cardTypeIcons[type] ? cardTypeIcons[type] : '';
}
